import { useEffect, useState } from "react";
import Testimonials from "../component/Testimonials";
import Invotation from "../component/Invotation";
import Questions from "../component/Questions";
import Footer from "../pages/Footer";

import WhiteStackLayers from "../component/WhiteStackLayers";

const Service = () => {
  const [visibleCount, setVisibleCount] = useState(0);

  return (
    <div className="  ">
      <div
        className="hidden md:block   w-full overflow-hidden mt-[5%] "
        id="red-section"
        data-bg="red"
      >
        <div className=" w-full px-20 bg-primary">
          <div className="flex flex-col items-center ">
            <button className="flex items-center gap-2 px-4 py-2 text-white border border-white rounded-md text-sm font-medium mt-10">
              <span className="w-2.5 h-2.5 rounded-full bg-white"></span>
              OUR SERVICE
            </button>

            <div className="w-full max-w-[1440px] h-[900px] ">
              <h1 className="text-[77px] font-clash font-normal text-white text-center mt-6 whitespace-nowrap text-nowrap">
                What We Build,{" "}
                <span className="font-semibold">Scales Your Business</span>
              </h1>

              <p className="text-white flex justify-center items-center  font-aileron font-normal  text-[24px] text-center">
                From ideas to execution, we design and develop digital solutions
                that help businesses grow faster and smarter.
              </p>

              <div className="mt-[3%]  bg-white rounded-3xl">
                <WhiteStackLayers />
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center w-full mt-8 px-4">
          {/*   <Testimonials /> */}
          <Invotation />
          <Questions />
        </div>
      </div>

      <div className="block md:hidden w-full ">
        <div className="w-full ">
          <div className="flex flex-col items-center bg-primary py-12 sm:py-16 px-4 sm:px-6 rounded-xl ">
            <button className="flex items-center gap-2 px-4 py-2 text-white border border-white rounded-md text-sm font-medium">
              <span className="w-2.5 h-2.5 rounded-full bg-white animate-pulse"></span>
              OUR SERVICE
            </button>

            <div className="w-full flex flex-col items-center mt-3 ">
              <h1 className="text-[22px]  font-clash font-normal text-white text-center  ">
                What We Build,{" "}
                <span className="font-semibold font-clash">
                  Scales Your Business
                </span>
              </h1>

              <p className="text-white text-center text-sm font-aileron font-normal tracking-wide  mt-3 ">
                From ideas to execution, we design and develop digital solutions
                that help businesses grow faster and smarter.
              </p>

              <div className="w-full mt-3 bg-white rounded-3xl   ">
                <WhiteStackLayers />
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center w-full mt-8">
          <Invotation />
          <Questions />
        </div>
      </div>
    </div>
  );
};

export default Service;
